<script setup lang="ts">
// types
import type { SectionRatingsGaugeProps } from '@ts-sections/section-ratings-gauge/interfaces'
// hooks
import { useSectionRatingsGauge } from '@hooks/sections/section-ratings-gauge.hook'
// components
import { CardIcon } from '@UI/Cards/CardIcon'
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import { RatingGauge } from '@UI/Ratings/RatingGauge'

defineOptions({
  name: 'SectionRatingsGauge',
})

const props = defineProps<{
  section: SectionRatingsGaugeProps
}>()

const {
  refTitle,
  refDescription,
  refBackgroundColor,
  getCriterionVisual,
} = useSectionRatingsGauge({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-ratings-gauge"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    :description="refDescription"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <div class="section-ratings-gauge__body">
      <div class="section-ratings-gauge__gauge">
        <RatingGauge />
      </div>
      <ul class="section-ratings-gauge__criteria">
        <li
          v-for="(criterion, index) in section.criteria"
          :key="criterion.id ?? index"
          class="section-ratings-gauge__criterion"
        >
          <CardIcon
            :title="criterion.title"
            v-bind="getCriterionVisual(index)"
          />
        </li>
      </ul>
    </div>
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionRatingsGauge.scss" />
